var map = {
	"./brand_facebook.svg": "7970",
	"./brand_github.svg": "c876",
	"./brand_instagram.svg": "a26e",
	"./brand_linkedin.svg": "a79b",
	"./brand_stackoverflow.svg": "f8a5",
	"./brand_tiktok.svg": "9ba6",
	"./brand_twitter.svg": "831c",
	"./brand_website.svg": "3c25c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a859";